import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const hasFirebasePackageConfig = Boolean(
  firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.projectId &&
    firebaseConfig.messagingSenderId &&
    firebaseConfig.appId
);

let packageFirebaseApp = null;
let packageAuth = null;

if (hasFirebasePackageConfig) {
  packageFirebaseApp = getApps().length
    ? getApp()
    : initializeApp(firebaseConfig);
  packageAuth = getAuth(packageFirebaseApp);
}

export { packageAuth };

export const createPackageRecaptchaVerifier = (containerId, callbacks = {}) => {
  if (!packageAuth) {
    throw new Error("Firebase package auth is not configured");
  }

  return new RecaptchaVerifier(packageAuth, containerId, {
    size: "normal",
    callback: callbacks.onSuccess,
    "expired-callback": callbacks.onExpired,
  });
};
